export default "__VITE_ASSET__BPOzilEI__"